export default "__VITE_ASSET__BMvkHBab__"